/**
 * isLoggedInUser — the canonical "is this a logged-in user (not a guest)" check
 * for the RFQ feature (decision #75 c11: RFQ is logged-in only for now; guests
 * sign up first). Mirrors the pattern used across the app
 * (`USER_DETAILS?.webuser?.userid != null`); a guest's USER_DETAILS is `{}`.
 *
 * @param {object} userDetails - state.route.USER_DETAILS
 * @returns {boolean}
 */
export const isLoggedInUser = (userDetails) =>
  Boolean(userDetails && userDetails.webuser && userDetails.webuser.userid != null);
